// useExcludeWrongSite - operator marks an ACTIVE upload as the WRONG SITE. This is
// a human EXCLUSION (status='removed'), NOT an AI quarantine: a deliberate human
// decision is settled, so it does not enter the quarantine review queue. The BE
// drops the file's contributions + recomputes, so this refreshes the uploads list
// and the operations dashboard. Reversible via
// useReinstateWrongSite.
import { useMutation, useQueryClient } from "react-query";

import { queryKeys } from "../queryKeys";
import { useAgentsHttp } from "../useAgentsHttp";
import { invalidateOperationsDashboard } from "./useOperationsDashboard";

export interface ExcludeWrongSiteInput {
  upload_id: string;
  // FE Kinde user.email, recorded as the actor (principle 27).
  user_email?: string;
  // Optional operator note + the other site they believe it belongs to.
  note?: string;
  detected_other_site?: string;
}

interface ExcludeWrongSiteResult {
  excluded: boolean;
  upload_id: string;
  project_id: string;
}

export const useExcludeWrongSite = (projectId: string) => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<ExcludeWrongSiteResult, Error, ExcludeWrongSiteInput>(
    async (payload) =>
      http<ExcludeWrongSiteResult>("/uploads/exclude-wrong-site", payload),
    {
      onSuccess: () => {
        qc.invalidateQueries({
          queryKey: queryKeys.uploadsList(projectId),
        });
        invalidateOperationsDashboard(qc);
      },
    },
  );
};
